export const blackList = {
    FORBIDDEN: 'forbidden',
}